import paymentMandateData from '@/shared/model/paymentMandateData';
import { BankDataState } from './types';

export const state = (): BankDataState => initialState();

export const initialState = (): BankDataState => ({
  isLoading: false,
  paymentMandate: paymentMandateData.parse(),
  paymentMandateHistory: [],
});
